export enum PermissionType {
  View = 1,
  Create = 2,
  Modify = 4,
  Delete = 8,
  Upgrade = 16,
}

export interface UserPermission {
  flags: PermissionType;
}
